<template>
  <div :class="$style.wrapper">
    <transition
      enter-active-class="fadeInDown"
      leave-active-class="fadeOut"
    >
      <b-row v-if="isMakeRosterQuestActive">
        <b-col :cols="12">
          <MakeRosterQuestLobby />
        </b-col>
      </b-row>
    </transition>
    <transition
      enter-active-class="fadeInDown"
      leave-active-class="fadeOut"
    >
      <b-row v-if="isInviteUsersQuestActive">
        <b-col :cols="12">
          <InviteUsersLobby />
        </b-col>
      </b-row>
    </transition>
    <div :class="$style.subNavWrapper">
      <b-row class="p-3">
        <b-col class="d-flex justify-content-center">
          <router-link
            :to="{ name: 'home'}"
            class="mr-1"
          >
            <BaseButton
              left-rounded
              size="sm"
              :variant="($route.name === 'home') ? 'orange' : 'outline-orange'"
            >
              <span class="px-3">{{ $t('active-rounds') }}</span>
            </BaseButton>
          </router-link>

          <router-link :to="{ name: 'closed-rounds'}">
            <BaseButton
              right-rounded
              size="sm"
              :variant="($route.name === 'closed-rounds') ? 'orange' : 'outline-orange'"
            >
              <span class="px-3">{{ $t('closed-rounds') }}</span>
            </BaseButton>
          </router-link>
        </b-col>
      </b-row>
    </div>

    <div :class="$style.content">
      <b-container>
        <transition-group
          tag="div"
          enter-active-class="fadeInDown"
          leave-active-class="fadeOutDown"
          :duration="{ enter: 1000, leave: 400 }"
          mode="out-in"
        >
          <template v-if="!isRoundsLoading || rounds.length">
            <div
              v-for="(round, index) in rounds"
              :key="`round-${round.id}`"
              :class="$style.roundWrapper"
              :style="{ animationDelay: `${index * 0.05}s`}"
            >
              <TheRoundLobbyRow :round="round" />
            </div>
          </template>
        </transition-group>
        <BaseAlert
          v-if="!isRoundsLoading && !rounds.length"
          is-center
          variant="light"
        >
          {{ $t('no-rounds-available') }}
        </BaseAlert>
      </b-container>
      <BaseLoading
        v-if="isRoundsLoading && !rounds.length"
        full-screen
      />
    </div>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies'
import { mapActions, mapState } from 'vuex'
import { ROUND_STATUSES } from '@/store/modules/rounds'
import TheRoundLobbyRow from '@/pages/Home/Components/Molecules/TheRoundLobbyRow'
import BaseAlert from '@/components/Atoms/BaseAlert'
import BaseButton from '@/components/Atoms/BaseButton'
import BaseLoading from '@/components/Atoms/BaseLoading'
import MakeRosterQuestLobby from '@/components/Organisms/Quests/MakeRosterXTimes/MakeRosterQuestLobby'
import InviteUsersLobby from '@/components/Organisms/Quests/InviteXUsers/InviteUsersLobby'

export default {
  name: 'HomeLoggedIn',
  components: {
    InviteUsersLobby,
    MakeRosterQuestLobby,
    BaseAlert,
    BaseLoading,
    BaseButton,
    TheRoundLobbyRow,
  },
  metaInfo() {
    return {
      title: this.$t('page-titles.home'),
      meta: [
        { name: 'description', content: this.$t('page-descriptions.home') },
      ],
    }
  },
  data() {
    return {
      roundStatuses: ROUND_STATUSES,
    }
  },
  computed: {
    ...mapState({
      isRoundsLoading: state => state['rounds/index'].isRoundsLoading,
      isMakeRosterQuestActive: state => state['quests/makeRosterQuest'].isActive,
      isInviteUsersQuestActive: state => state['quests/inviteUsersQuest'].isActive,
      gameType: state => state['game/type'].type,
    }),
    rounds() {
      if (this.roundStatus === 'active') {
        return this.$store.getters['rounds/index/getActiveRounds'](this.gameType)
      } else {
        return this.$store.getters['rounds/index/getInactiveRounds'](this.gameType)
      }
    },
    roundStatus() {
      return (this.$route.name === 'home') ? 'active' : 'closed'
    },
  },
  watch: {
    gameType(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.fetchRounds({
          status: this.roundStatus,
          type: this.gameType,
        })
      }
    },
  },
  created() {
    const redirect = VueCookies.get('redirect')
    if (redirect) {
      VueCookies.remove('redirect')
      window.location.href = redirect
    } else {
      this.fetchRounds({
        status: this.roundStatus,
        type: this.gameType,
      })
    }
  },
  methods: {
    ...mapActions({
      fetchRounds: 'rounds/index/fetchRounds',
    }),
  },
}
</script>

<style lang="scss" module>
  @import '../../../../assets/scss/variables';
  .wrapper {
    width: 100%;
    .subNavWrapper {
      background-color: $color-bleached-silk;
    }
    .roundWrapper {
      border-bottom: 2px solid $color-bleached-silk;
    }
    .content {
      width: 100%;
      overflow-x: hidden;
    }
  }
</style>
